import { motion } from "framer-motion";

const stats = [
  { value: "60", unit: "words", label: "avg story length", id: "metric-words" },
  { value: "3-way", unit: "radar", label: "source comparison", id: "metric-sources" },
  { value: "12+", unit: "languages", label: "regional support", id: "metric-languages" },
  { value: "100%", unit: "AI-screened", label: "every single story", id: "metric-ai" },
];

const MetricsBar = () => (
  <section data-testid="metrics-bar" className="border-y border-[#1E293B] bg-[#0B111C]/60">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 grid grid-cols-2 lg:grid-cols-4 gap-8">
      {stats.map((s, i) => (
        <motion.div
          key={s.id}
          data-testid={s.id}
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: i * 0.08 }}
          className="flex flex-col"
        >
          <span className="font-display text-3xl sm:text-4xl font-bold text-slate-50">
            {s.value}
            <span className="text-cyan-400 text-lg sm:text-xl ml-1.5">{s.unit}</span>
          </span>
          <span className="mt-2 text-xs font-mono-x uppercase tracking-widest text-slate-500">{s.label}</span>
        </motion.div>
      ))}
    </div>
  </section>
);

export default MetricsBar;
